import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Reply"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21.6604 22.5C21.3888 22.5038 21.1363 22.3603 21.0004 22.125C18.9684 18.6633 15.2645 16.5264 11.2504 16.5V21C11.2489 21.3028 11.0655 21.575 10.7854 21.69C10.5061 21.8075 10.1836 21.7453 9.96794 21.5325L0.967943 12.5325C0.825958 12.3917 0.746094 12.2 0.746094 12C0.746094 11.8 0.825958 11.6083 0.967943 11.4675L9.96794 2.4675C10.1836 2.25469 10.5061 2.19256 10.7854 2.31C11.0655 2.42506 11.2489 2.69723 11.2504 3V7.5825C17.6688 8.40689 22.4816 13.8614 22.5004 20.3325C22.4987 20.834 22.4661 21.335 22.4029 21.8325C22.3645 22.1525 22.126 22.4121 21.8104 22.4775L21.6604 22.5ZM10.8754 15C14.7466 14.9444 18.4475 16.5893 21.0004 19.5C20.5343 13.8799 16.0559 9.4301 10.4329 9.00001C10.0452 8.96498 9.74881 8.63923 9.75039 8.25001V4.80751L2.55789 12L9.75039 19.1925V15.75C9.75039 15.3358 10.0862 15 10.5004 15H10.9054H10.8754Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Reply.vue"]]);
